import FullscreenPopup from './FullscreenPopup';

export default FullscreenPopup;
